import { render, staticRenderFns } from "./formFacebook.vue?vue&type=template&id=e092cb94&"
import script from "./formFacebook.vue?vue&type=script&lang=js&"
export * from "./formFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports